import { getDeviceInfo } from "@discovery/maestro-env-browser";
import { VERSION } from "./env";
/**
 * Allows one to grab the device id from either local storage (if exist) or
 * generate a new one.
 *
 * envBrowser uses `indexedDB -> localStorage -> cookieStorage -> * sessionStorage`
 * in priority order and also uses `fingerprintjs2` as id generator
 */
export const clientInformation = Object.assign({ application: {
        name: "dplusin",
        version: VERSION !== null && VERSION !== void 0 ? VERSION : "no application.version",
    } }, getDeviceInfo());

